var _ = require('underscore');
var Activity = require('RecordActivityLog');
var Labels = EY.Consultation.Labels;
var Lookups = EY.Consultation.Lookups;

module.exports.run = function (options) {
    var approvers = options.approvers;
    var record = options.record;

    Activity.log(_.extend({ text: Labels.Activity_ReturnForRevision + ' Reason: ' + record.get('returnReason') }, options));
    approvers.each(function (approver) {
        approver.set({
            approval: '',
            comments: '',
            recusal: approver.get('recusal') === '' ? '' : false,
            independence: approver.get('independence') === '' ? '' : false,
            acknowledgeStatus: '',
            acknowledgeDate: ''
        });
    });
    record.set({
        approverGroupId: '',
        assignedTo: record.get('createdBy'),
        assignedToGivenName: record.get('creatorGivenName'),
        validChecksum: true,
        statusTypeId: Lookups.StatusType.ReturnForRevision
    });
};


// WEBPACK FOOTER //
// ./js/Modules/Record/Action/RecordActionReturn.js